"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentToJSON = exports.EnrollmentFromJSONTyped = exports.EnrollmentFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function EnrollmentFromJSON(json) {
    return EnrollmentFromJSONTyped(json, false);
}
exports.EnrollmentFromJSON = EnrollmentFromJSON;
function EnrollmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'applicationId': !runtime_1.exists(json, 'applicationId') ? undefined : json['applicationId'],
        'planSelection': !runtime_1.exists(json, 'planSelection') ? undefined : _1.PlanSelectionQueryFromJSON(json['planSelection']),
        'eligibility': !runtime_1.exists(json, 'eligibility') ? undefined : _1.PreEligibilityStepFromJSON(json['eligibility']),
        'citizenship': !runtime_1.exists(json, 'citizenship') ? undefined : _1.PreCitizenshipStepFromJSON(json['citizenship']),
        'documentCheck': !runtime_1.exists(json, 'documentCheck') ? undefined : _1.PreDocumentCheckStepFromJSON(json['documentCheck']),
        'biographicInfo': !runtime_1.exists(json, 'biographicInfo') ? undefined : _1.PreBiographicInfoStepFromJSON(json['biographicInfo']),
        'contact': !runtime_1.exists(json, 'contact') ? undefined : _1.PreContactStepFromJSON(json['contact']),
        'attributes': !runtime_1.exists(json, 'attributes') ? undefined : _1.PreAttributesStepFromJSON(json['attributes']),
        'identityHints': !runtime_1.exists(json, 'identityHints') ? undefined : _1.PreIdentityStepFromJSON(json['identityHints']),
        'addresses': !runtime_1.exists(json, 'addresses') ? undefined : _1.PreAddressesStepFromJSON(json['addresses']),
        'legal': !runtime_1.exists(json, 'legal') ? undefined : _1.PreLegalQuestionnaireStepFromJSON(json['legal']),
        'documents': !runtime_1.exists(json, 'documents') ? undefined : _1.PreDocumentUploadStepQueryFromJSON(json['documents']),
        'photoIdDocuments': !runtime_1.exists(json, 'photoIdDocuments') ? undefined : (json['photoIdDocuments'].map(_1.AttachmentPhotoIdModelFromJSON)),
        'citizenshipDocuments': !runtime_1.exists(json, 'citizenshipDocuments') ? undefined : (json['citizenshipDocuments'].map(_1.AttachmentModelFromJSON)),
        'nameLinkingDocuments': !runtime_1.exists(json, 'nameLinkingDocuments') ? undefined : (json['nameLinkingDocuments'].map(_1.AttachmentModelFromJSON)),
        'faces': !runtime_1.exists(json, 'faces') ? undefined : (json['faces'].map(_1.AttachmentModelFromJSON)),
        'finalized': !runtime_1.exists(json, 'finalized') ? undefined : _1.PreFinalizeStepQueryFromJSON(json['finalized']),
        'ssn': !runtime_1.exists(json, 'ssn') ? undefined : _1.SsnStepFromJSON(json['ssn']),
        'ktn': !runtime_1.exists(json, 'ktn') ? undefined : _1.KtnModelFromJSON(json['ktn']),
        'clearPromotionsOptIn': !runtime_1.exists(json, 'clearPromotionsOptIn') ? undefined : json['clearPromotionsOptIn'],
        'hands': !runtime_1.exists(json, 'hands') ? undefined : _1.HandsModelFromJSON(json['hands']),
        'handRequirements': !runtime_1.exists(json, 'handRequirements') ? undefined : _1.HandRequirementsModelFromJSON(json['handRequirements']),
        'agreements': !runtime_1.exists(json, 'agreements') ? undefined : _1.AgreementsFromJSON(json['agreements']),
        'paymentInfo': !runtime_1.exists(json, 'paymentInfo') ? undefined : _1.PaymentInfoQueryFromJSON(json['paymentInfo']),
        'enrollmentState': !runtime_1.exists(json, 'enrollmentState') ? undefined : _1.EnrollmentStateFromJSON(json['enrollmentState']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.MetadataModelFromJSON(json['metadata']),
    };
}
exports.EnrollmentFromJSONTyped = EnrollmentFromJSONTyped;
function EnrollmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'applicationId': value.applicationId,
        'planSelection': _1.PlanSelectionQueryToJSON(value.planSelection),
        'eligibility': _1.PreEligibilityStepToJSON(value.eligibility),
        'citizenship': _1.PreCitizenshipStepToJSON(value.citizenship),
        'documentCheck': _1.PreDocumentCheckStepToJSON(value.documentCheck),
        'biographicInfo': _1.PreBiographicInfoStepToJSON(value.biographicInfo),
        'contact': _1.PreContactStepToJSON(value.contact),
        'attributes': _1.PreAttributesStepToJSON(value.attributes),
        'identityHints': _1.PreIdentityStepToJSON(value.identityHints),
        'addresses': _1.PreAddressesStepToJSON(value.addresses),
        'legal': _1.PreLegalQuestionnaireStepToJSON(value.legal),
        'documents': _1.PreDocumentUploadStepQueryToJSON(value.documents),
        'photoIdDocuments': value.photoIdDocuments === undefined ? undefined : (value.photoIdDocuments.map(_1.AttachmentPhotoIdModelToJSON)),
        'citizenshipDocuments': value.citizenshipDocuments === undefined ? undefined : (value.citizenshipDocuments.map(_1.AttachmentModelToJSON)),
        'nameLinkingDocuments': value.nameLinkingDocuments === undefined ? undefined : (value.nameLinkingDocuments.map(_1.AttachmentModelToJSON)),
        'faces': value.faces === undefined ? undefined : (value.faces.map(_1.AttachmentModelToJSON)),
        'finalized': _1.PreFinalizeStepQueryToJSON(value.finalized),
        'ssn': _1.SsnStepToJSON(value.ssn),
        'ktn': _1.KtnModelToJSON(value.ktn),
        'clearPromotionsOptIn': value.clearPromotionsOptIn,
        'hands': _1.HandsModelToJSON(value.hands),
        'handRequirements': _1.HandRequirementsModelToJSON(value.handRequirements),
        'agreements': _1.AgreementsToJSON(value.agreements),
        'paymentInfo': _1.PaymentInfoQueryToJSON(value.paymentInfo),
        'enrollmentState': _1.EnrollmentStateToJSON(value.enrollmentState),
        'metadata': _1.MetadataModelToJSON(value.metadata),
    };
}
exports.EnrollmentToJSON = EnrollmentToJSON;
//# sourceMappingURL=Enrollment.js.map